import { render, staticRenderFns } from "./theme-three.vue?vue&type=template&id=5c2bc4d8&"
import script from "./theme-three.vue?vue&type=script&lang=js&"
export * from "./theme-three.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports